const related = [
  {
    href: 'https://sodiocorrigido.com.br/',
    title: 'Sódio corrigido',
    text: 'Na hiperglicemia, compare a estimativa de sódio corrigido com a leitura de osmolaridade.'
  },
  {
    href: 'https://aniongap.com.br/',
    title: 'Ânion gap',
    text: 'Em avaliações de acidose, o ânion gap é outro cálculo e não deve ser confundido com o gap osmolar.'
  },
  {
    href: 'https://clearancecreatinina.com.br/',
    title: 'Clearance de creatinina',
    text: 'A ureia participa da fórmula osmolar, enquanto o clearance estima uma dimensão diferente da função renal.'
  },
  {
    href: 'https://calciocorrigido.com.br/',
    title: 'Cálcio corrigido',
    text: 'Uma estimativa complementar para cálcio e albumina, independente da osmolaridade.'
  }
];


function RelatedCalculators() {
  return (
    <section className="related-section">
      <div className="related-heading">
        <h2>Quais calculadoras podem complementar esta consulta?</h2>
        <p>Ferramentas relacionadas abordam outras perguntas laboratoriais e clínicas.</p>
      </div>
      <div className="related-grid">
        {related.map((item) => (
          <article className="related-item" key={item.href}>
            <h3><a href={item.href}>{item.title}</a></h3>
            <p>{item.text}</p>
          </article>
        ))}
      </div>
    </section>
  );
}

export default RelatedCalculators;
